export default async function convertBase64ToFile(base64Data: string): Promise<File> {
  const block = base64Data.split(';');
  const mimeType = block[0].split(':')[1];
  const type = mimeType.split('/')[1];
  const response: Response = await fetch(base64Data);
  const blob: Blob = await response.blob();
  return new File([blob], `${new Date().getTime()}.${type}`, { type: mimeType });
}

export const isBase64 = (value: string): boolean => {
  const pattern = new RegExp('data:image\/([a-zA-Z]*);base64,([^\"]*)', 'g');
  return Boolean(value.match(pattern));
}